import React from 'react';

import type { IImgUrlOptions } from './types';
import { createImgUrl } from './utils';

type ImgUrlFn = (src: string, options: IImgUrlOptions) => string;

const ImageContext = React.createContext<ImgUrlFn | undefined>(undefined);

export function useImgUrl(): ImgUrlFn {
  const value = React.useContext(ImageContext);
  if (value === undefined) {
    throw new Error('useImgUrl must be used within an <ImageProvider>');
  }
  return value;
}

export function ImageProvider({
  baseUrl,
  children,
}: {
  baseUrl: string;
  children: React.ReactNode;
}) {
  const imgUrl = React.useMemo(() => createImgUrl(baseUrl), [baseUrl]);

  return <ImageContext.Provider value={imgUrl}>{children}</ImageContext.Provider>;
}
